
import { Component, Vue } from 'vue-property-decorator'
import MobileMenu from '@/components/MobileMenu.vue'
import MobileBanner from '@/components/MobileHomeCarousel.vue'
import MobileNews from '@/components/MobileHomeNews.vue'
import MobileEntries from './components/MobileHomeEntries.vue'
import MobileTradeNews from '@/components/MobileTradeNews.vue'
import Links from './components/MobileLinks.vue'
import ContactUs from './components/MobileContactUs.vue'
import { IndexManager } from './manager'
import { IndexService } from './service'
import MobileSelectedCourse from './components/MobileSelectedCourse.vue'
import MobileMap from '../index/components/MobileMap.vue'
import MobileHomeTwoNews from '@/components/MobileHomeTwoNews.vue'

@Component({
  name: 'SmallScreen',
  components: {
    MobileMenu,
    MobileBanner,
    MobileNews,
    MobileEntries,
    MobileTradeNews,
    Links,
    ContactUs,
    MobileSelectedCourse,
    MobileMap,
    MobileHomeTwoNews
  }
})
export default class extends Vue {
  private indexManager: IndexManager = new IndexManager(new IndexService())
  private url = ''

  mounted () {
    // localStorage.removeItem('contactUsInfo')
    // this.gethomeConfig()
    // this.getZixunMenuChild()
    this.url = 'https://tcwta.tcwta.org.cn/'
  }
}
